const BASE_URL = process.env.REACT_APP_BASE_URL

// Logout
//export const API_LOGOUT_URL: string = 'http://localhost:8080/auth/logout'
//export const API_LOGOUT_URL: string = 'https://bos.beconx.live/api/v1/logout'
export const API_LOGOUT_URL: string = (BASE_URL + '/identity_manager/api/v1/logout')

export type APILogoutTypes = {
    accessToken: string;
}

// Login
//export const API_LOGIN_URL: string = 'http://localhost:8080/auth/login'
//export const API_LOGIN_URL: string = 'https://bos.beconx.live/api/v1/login'
// export const API_LOGIN_URL: string = 'https://bos.beconx.live/api/v1/login'
export const API_LOGIN_URL: string = (BASE_URL + '/identity_manager/api/v1/login-bconex')

export type APILoginType = {
    username: string;
    password: string;
    codeChallenge: string;
}

// Get access token
export const API_GET_ACCESS_TOKEN_URL: string = 'http://localhost:8080/auth/token'

export type APIGetAccessTokenType = {
    code: string;
    codeVerifier: string;
}

// Get refresh token
export const API_GET_REFRESH_TOKEN: string = 'http://localhost:8080/auth/refresh'

export type APIGetRefreshTokenType = {
    accessToken: string;
}

export type APIResponseRefreshTokenType = {
    accessToken: string;
}

// Register new user
export const API_REGISTER_USER_URL: string = 'http://localhost:8080/auth/register'

export type APIRegisterUserTypes = {
    username: string;
    password: string;
    role: string[];
}

// Get all roles
export const API_GET_ALL_ROLES: string = 'http://localhost:8080/auth/get-all-roles'

export type APIResponseGetAllRolesType = {
    id: string;
    role: string;
}